'use strict';
import axios from 'axios';
import store from '../store';

export default class EmailEligibility {
	/**
	 * @returns {Promise<boolean>}
	 */
	static async checkEligibility(msisdn) {
		let url = '';
		if (process.env.NODE_ENV === 'development') {
			url = `/api/emailEligibility/${msisdn}`;
		} else {
			url = `../${store.getters.getConfig['email_eligibility_url'].replace(
				'{msisdn}',
				msisdn
			)}`;
		}
		const { data } = await axios.get(url);

		const targetEligibility = data.eligibilities.find(
			(eligibility) => eligibility.eventCode === '4'
		);

		return Boolean(targetEligibility?.flag);
	}
}
